export default __webpack_public_path__ + "fb4c716ddaada5e72e51559c827baa29.svg";